import { TreeRow } from '../../../containers/BulkSheetView/model'
import { AgGridTreeHelper } from '../../../containers/BulkSheetView/lib/tree'
import { ProgramProjectReportDto } from '../../../../infrastructure/api/program-project-reports'

export const PROGRAM_PROJECT_REPORT_ROW_TYPE = {
  PROJECT: 'PROJECT',
  WORKGROUP: 'WORKGROUP',
  PROCESS: 'PROCESS',
} as const

export type ProgramProjectReportRowType =
  (typeof PROGRAM_PROJECT_REPORT_ROW_TYPE)[keyof typeof PROGRAM_PROJECT_REPORT_ROW_TYPE]

export type ProgramProjectReportProgress = {
  total: number | null
  scheduledCompleted: number | null
  completed: number | null
  delayed: number | null
  preceding: number | null
}

export type ProgramProjectReportResource = {
  totalResource: number | null
  investedResource: number | null
  scheduledResource: number | null
  actualResource: number | null
}

export type ProgramProjectReportProfitLoss = {
  totalBudget: number | null
  scheduledUsedBudget: number | null
  actualUsedBudget: number | null
  remainingBudget: number | null
  totalRevenue: number | null
  scheduledRevenue: number | null
  actualRevenue: number | null
  forecastRevenue: number | null
}

export type ProgramProjectReportRow = TreeRow & {
  type: ProgramProjectReportRowType
  code: string | null
  displayName: string | null
  status: string | null
  scheduledStartDate: string | null
  scheduledEndDate: string | null
  progress: ProgramProjectReportProgress | null
  resource: ProgramProjectReportResource | null
  profitLoss: ProgramProjectReportProfitLoss | null
}

const toRow = (dto: ProgramProjectReportDto): ProgramProjectReportRow => ({
  uuid: dto.uuid,
  treeValue: [],
  type: dto.type,
  code: dto.code,
  displayName: dto.displayName,
  status: dto.status,
  scheduledStartDate: dto.scheduledDate?.startDate ?? null,
  scheduledEndDate: dto.scheduledDate?.endDate ?? null,
  progress: dto.progress?.hour ?? null,
  resource: dto.resource,
  profitLoss: dto.profitLoss,
  revision: dto.revision ?? undefined,
  createdBy: dto.createdBy ?? undefined,
  createdAt: dto.createdAt ?? undefined,
  updatedBy: dto.updatedBy ?? undefined,
  updatedAt: dto.updatedAt ?? undefined,
})

export const toProgramProjectReportRows = (
  root: ProgramProjectReportDto
): ProgramProjectReportRow[] => AgGridTreeHelper.convert(root, toRow)
